// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__d3+hQ","header":"styles_header__L+a4q","back":"styles_back__zUkmz"};